"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SmartHeader = exports.Header = undefined;

var _header = require("./header");

var _header2 = _interopRequireDefault(_header);

var _smartHeader = require("./smartHeader");

var _smartHeader2 = _interopRequireDefault(_smartHeader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Header = _header2.default;
exports.SmartHeader = _smartHeader2.default;